module.exports = __webpack_public_path__ + "static/media/ch.a69a50e5.svg";